import f from "./_root.js";
import t from "./stubFalse.js";
var r = typeof exports == "object" && exports && !exports.nodeType && exports, e = r && typeof module == "object" && module && !module.nodeType && module, u = e && e.exports === r, o = u ? f.Buffer : void 0, s = o ? o.isBuffer : void 0, p = s || t;
const m = p;
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isBuffer.js
// module id = 316
// module chunks = 67